import { render, staticRenderFns } from "./StockPrint3.vue?vue&type=template&id=45d310bc&scoped=true&"
import script from "./StockPrint3.vue?vue&type=script&lang=js&"
export * from "./StockPrint3.vue?vue&type=script&lang=js&"
import style0 from "./StockPrint3.vue?vue&type=style&index=0&id=45d310bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d310bc",
  null
  
)

export default component.exports